import { IconButton } from 'react-native-paper';
import { useAppTheme } from '../theme';
import { useNavigation, DrawerActions } from '@react-navigation/native';

export default function DrawerButton() {
  const theme = useAppTheme();
  const navigation = useNavigation();

  return (
    <IconButton
      icon="menu"
      mode="contained"
      onPress={() => {
        navigation.dispatch(DrawerActions.openDrawer);
      }}
      style={{
        backgroundColor: 'transparent',
      }}
      iconColor={theme.colors.onBackground}
    />
  );
}
